class SkinConcernsComponent extends HTMLElement {
	constructor() {
	  super();
	  this.readMoreButtons = this.querySelectorAll('.skin-concerns__text.has-read-more')
	  this.readMoreButtons.forEach(button => button.addEventListener('click', this.onReadMoreClick.bind(this)));

	  this.nextImageButtons = this.querySelectorAll('.skin-concerns__button.button--next')
	  this.nextImageButtons.forEach(button => button.addEventListener('click', this.onNextImageClick.bind(this)));

	  this.backImageButtons = this.querySelectorAll('.skin-concerns__button.button--back')
	  this.backImageButtons.forEach(button => button.addEventListener('click', this.onBackImageClick.bind(this)));
	}

	onReadMoreClick(event) {
		event.preventDefault();
		event.currentTarget.classList.toggle('show')
	}

	onNextImageClick(event) {
		event.preventDefault();
		event.target.closest('.skin-concerns__image').classList.add('show-next')
	}

	onBackImageClick(event) {
		event.preventDefault();
		event.target.closest('.skin-concerns__image').classList.remove('show-next')
	}
}

customElements.define('skin-concerns-component', SkinConcernsComponent);